import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root',
})
export class StringService {

    constructor(private configService: ConfigService) { }

    public isEmpty(str: any): boolean {
        if (str == null ||
      str === undefined ||
      str === '') {
            return true;
        }
        return false;
    }

    public isNotEmpty(str: any): boolean {
        if (str !== null &&
      str !== undefined &&
      str !== '') {
            return true;
        }
        return false;
    }

    public isInvalidEmail1(email: string): boolean {
        if (email === '' ||
      email === undefined ||
      email == null) {
            return true;
        }

        if (email.search(/^[a-zA-Z0-9]+[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[a-zA-Z0-9.]{2,5}$/) === -1) {
            return true;
        }

        return false;
    }

    public isInvalidPassword(password: string): boolean {
        if (password === undefined ||
      password == null ||
      password === '') {
            return true;
        }

        if (password.length < 6) {
            return true;
        } else if (password.search(/\d/) === -1) {
            return true;
        }

        // else if (password.search(/[A-Z]/) == -1) {
        //     return true;
        // }

        return false;
    }

    public isNotNumberic(inputtedTxt): boolean {
        if (isNaN(inputtedTxt)) {
            return true;
        }
        return false;
    }   

    public isNotValidAddress1(address: string): boolean {
        const filterStrings = this.configService.config.address1NotAllowStringFilter;
        if(filterStrings == null || filterStrings.length == 0 || this.isEmpty(address))
        {
            return false;
        }

        for (let a = 0; a < filterStrings.length; a++) {
            if (this.isNotEmpty(address.toUpperCase().match(filterStrings[a].toUpperCase()))) { 
                return true;
            }
        }

        return false;
    }

}
